import crossDockingNews from "../../../../content/platform-news/cross-docking-2026";

export const crossDockingStages = [
    {
        id: "receipt",
        number: "01",
        icon: "receipt",
        statusTone: "completed",
        titleKey:
            "main.landing.crossDocking.stages.receipt.title",
        descriptionKey:
            "main.landing.crossDocking.stages.receipt.description",
        statusKey:
            "main.landing.crossDocking.stages.receipt.status",
        operationKey:
            "main.landing.crossDocking.stages.receipt.operation",
        platformKey:
            "main.landing.crossDocking.stages.receipt.platform",
        resultKey:
            "main.landing.crossDocking.stages.receipt.result",
    },
    {
        id: "distribution",
        number: "02",
        icon: "distribution",
        statusTone: "active",
        titleKey:
            "main.landing.crossDocking.stages.distribution.title",
        descriptionKey:
            "main.landing.crossDocking.stages.distribution.description",
        statusKey:
            "main.landing.crossDocking.stages.distribution.status",
        operationKey:
            "main.landing.crossDocking.stages.distribution.operation",
        platformKey:
            "main.landing.crossDocking.stages.distribution.platform",
        resultKey:
            "main.landing.crossDocking.stages.distribution.result",
    },
    {
        id: "dispatch",
        number: "03",
        icon: "dispatch",
        statusTone: "planned",
        titleKey:
            "main.landing.crossDocking.stages.dispatch.title",
        descriptionKey:
            "main.landing.crossDocking.stages.dispatch.description",
        statusKey:
            "main.landing.crossDocking.stages.dispatch.status",
        operationKey:
            "main.landing.crossDocking.stages.dispatch.operation",
        platformKey:
            "main.landing.crossDocking.stages.dispatch.platform",
        resultKey:
            "main.landing.crossDocking.stages.dispatch.result",
    },
];

export const crossDockingDefaultStageId =
    crossDockingStages[0].id;

export const crossDockingBenefitKeys = [
    "main.landing.crossDocking.sales.benefits.storage",
    "main.landing.crossDocking.sales.benefits.operations",
    "main.landing.crossDocking.sales.benefits.delivery",
    "main.landing.crossDocking.sales.benefits.requests",
];

export const crossDockingWorkspaceItems = [
    {
        id: "create",
        labelKey:
            "main.landing.crossDocking.workspace.items.create",
        tone: "accent",
    },
    {
        id: "actual",
        labelKey:
            "main.landing.crossDocking.workspace.items.actual",
        tone: "active",
    },
    {
        id: "archive",
        labelKey:
            "main.landing.crossDocking.workspace.items.archive",
        tone: "neutral",
    },
];

export const crossDockingNewsHref =
    `/news/${crossDockingNews.slug}`;
